import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import Card from '@/components/material-ui-kit/components/Card/Card';
import CardHeader from '@/components/material-ui-kit/components/Card/CardHeader';
import CardBody from '@/components/material-ui-kit/components/Card/CardBody';
import styles from 'styles/jss/original/components/menus/menuModalListItem';
import LazyLoadImage from '@/components/common/ui/LazyloadImage';
import { useMedia } from 'react-use';
import { IMenuTaxonomy } from '@/@types/generated/contentful';

const IMAGE_HEIGHT_PC = 90;
const IMAGE_HEIGHT_SP = 150;

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  taxonomy: IMenuTaxonomy;
  onRequestClick: () => void;
};

const MenuModalListItem: React.FC<ComponentProps> = ({ taxonomy, onRequestClick }) => {
  const classes = useStyles();
  const isSp = useMedia('(max-width: 640px)');
  const [imageHeight, setImageHeight] = useState(IMAGE_HEIGHT_PC);
  useEffect(() => {
    if (isSp) setImageHeight(IMAGE_HEIGHT_SP);
  }, [isSp]);
  return (
    // @ts-expect-error
    <GridItem xs={6} sm={4} md={6} key={taxonomy.fields.id}>
      <Card profile plain className={classes.card}>
        <Link href={`/menus-taxonomy/${taxonomy.fields.slug}`}>
          <a onClick={onRequestClick}>
            <GridContainer className={classes.alignCenter}>
              {/* @ts-expect-error */}
              <GridItem xs={12} sm={12} md={5}>
                <CardHeader image plain>
                  <LazyLoadImage height={imageHeight}>
                    {(onLoad) => (
                      <picture>
                        <source
                          srcSet={`${taxonomy.fields.thumbnail.fields.file.url}?fm=webp`}
                          media='(min-width: 641px)'
                          onLoad={onLoad}
                        />
                        <source
                          srcSet={`${taxonomy.fields.thumbnail.fields.file.url}?fm=webp&fit=pad&w=300`}
                          media='(max-width: 640px)'
                          onLoad={onLoad}
                        />
                        <img
                          src={`${taxonomy.fields.thumbnail.fields.file.url}?fit=pad&w=200`}
                          alt={taxonomy.fields.title}
                          onLoad={onLoad}
                        />
                      </picture>
                    )}
                  </LazyLoadImage>
                  <div className={classes.coloredShadow} />
                </CardHeader>
              </GridItem>
              {/* @ts-expect-error */}
              <GridItem xs={12} sm={12} md={7}>
                <CardBody plain className={classes.cardBody}>
                  <h5 className={classes.cardTitle}>{taxonomy.fields.title}</h5>
                </CardBody>
              </GridItem>
            </GridContainer>
          </a>
        </Link>
      </Card>
    </GridItem>
  );
};

export default MenuModalListItem;
